import { useImperativeHandle, useState, forwardRef } from 'react';
import { Col, Row } from 'antd';
import PropTypes from 'prop-types';

import { PublishHeaderSection } from 'pages/Proposal/components/Publish/components/PublishContent/components';
import { ContentLoader } from 'pages/ContentLibrary/components/ContentLoader/ContentLoader';
import helpers from 'helpers';
import ConfirmModal from 'components/ConfirmModal';

import './Headers.scss';

const Headers = forwardRef(
  ({ refetchSections, isLoadingMoreSections, sections, saveProposal, processFetchedData }, ref) => {
    const [changeHeaderModal, showChangeHeaderModal] = useState(false);
    const [selectedHeaderId, setSelectedHeaderId] = useState(null);

    /**
     * Use imperative handle
     */
    useImperativeHandle(ref, () => ({
      async reloadItems() {
        const data = await refetchSections();
        processFetchedData(data, true);
      },
    }));

    /**
     * Update header click
     * @param {string} header_id
     * @returns {void}
     */
    const updateHeaderClick = (header_id) => {
      setSelectedHeaderId(header_id);
      showChangeHeaderModal(true);
    };

    /**
     * Update header
     * @returns {void}
     */
    const updateHeader = () => {
      const headerData = JSON.parse(
        JSON.stringify(sections.find((section) => section._id === selectedHeaderId) || {})
      );

      [
        '_id',
        'auid',
        'uid',
        'libraryTitle',
        'thumbnail',
        'createdAt',
        'cursorId',
        'starred',
      ].forEach((key) => delete headerData[key]);

      saveProposal({
        'draft.header': headerData,
      });

      showChangeHeaderModal(false);
      localStorage.setItem('headerChanged', true);
    };

    return (
      <>
        <Row gutter={[15, 24]} className="library-sections-container">
          {sections?.length > 0 &&
            sections?.map((item, itemIndex) => (
              <Col
                span={24}
                // draggable
                // onDragStart={(event) => dragStart(event, item)}
                // onDragEnd={dragEnd}
                className="cursor-pointer"
                id={`proposal-header-${item._id}`}
                data-section={JSON.stringify(item)}
                key={itemIndex + item._id}
                onClick={() => updateHeaderClick(item._id)}>
                {item.thumbnail ? (
                  <div
                    className={`header-section thumbnail ${
                      item ? `language-${item?.language?.toLowerCase() || 'english'}` : ''
                    }`}
                    style={{ backgroundImage: `url("${helpers.formatS3Link(item?.thumbnail)}")` }}
                  />
                ) : (
                  <div className="header-section" style={{ flexDirection: 'column' }}>
                    <PublishHeaderSection
                      proposal={{ draft: { item } }}
                      name="item"
                      isPreview={true}
                      configText={(x) => x}
                      ispdf={false}
                    />
                  </div>
                )}
                <Row className={`section-title ${item.language === 'hebrew' ? 'hebrew' : ''}`}>
                  <span>{item.libraryTitle}</span>
                </Row>
              </Col>
            ))}
        </Row>

        {isLoadingMoreSections && <ContentLoader />}

        {changeHeaderModal && (
          <ConfirmModal
            title="Are You Sure?"
            body="This will replace the current header"
            visible={changeHeaderModal}
            cancelText="CANCEL"
            promptType={'update'}
            confirmText="YES, UPDATE"
            onCancel={() => showChangeHeaderModal(false)}
            onConfirm={updateHeader}
          />
        )}
      </>
    );
  }
);

Headers.propTypes = {
  refetchSections: PropTypes.func.isRequired,
  isLoadingMoreSections: PropTypes.bool.isRequired,
  sections: PropTypes.array.isRequired,
  saveProposal: PropTypes.func.isRequired,
  processFetchedData: PropTypes.func.isRequired,
};

export default Headers;
